import { TeamLegalCasesState } from './partials/legal_cases'
import { TeamMemberState } from './partials/members'
import { TeamPartyState } from './partials/parties'
import { TeamRecordState } from './partials/records'
import { TeamRoleState } from './partials/roles'

export const TeamState = {
  teams: [],
  ...TeamLegalCasesState,
  ...TeamMemberState,
  ...TeamPartyState,
  ...TeamRecordState,
  ...TeamRoleState,
}
